import { render, staticRenderFns } from "./done-tab4.vue?vue&type=template&id=6e9a2cff&"
import script from "./done-tab4.vue?vue&type=script&lang=ts&"
export * from "./done-tab4.vue?vue&type=script&lang=ts&"
import style0 from "./done-tab4.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports